export const translations = {
  en: {
    JOIN_STAGE: "Get on stage!",
    JOIN_YOUR_STAGE: "Join your stage!",
    MADE_BY_ARTISTS: "made by artists.",
    FOR_ARTISTS: "for artists.",
    SIGN_IN: "Sign In",
    SIGN_UP: "Sign Up",
    LOGOUT: "Log Out",
    SEARCH_PLACEHOLDER: "Search opportunities, users, bands...",
    NAV_HOME: "Home",
    NAV_MESSAGES: "Messages",
    NAV_NOTIFICATIONS: "Alerts",
    NAV_NETWORK: "Network",
    NAV_ACTIVITY: "Activity",
    NAV_POST_OPP: "Post Opportunity",
    NAV_MANAGE_APPLICANTS: "Manage Applicants",
    NAV_FOR_YOU: "For You",
    NAV_MY_LINEUPS: "My Lineups",
    NAV_MY_FLYERS: "My Flyers",
    NAV_MY_BANDS: "My Bands",
    NAV_PROFILE_MANAGER: "Manage Profiles",
    NAV_PUMP_UP: "Pump Up The Volume",
    BACK: "Back",
    MESSAGE: "Message",
    ENDORSE: "Endorse",
    ENDORSED: "Endorsed",
    ENDORSED_BY: "Endorsed By",
    ABOUT: "About",
    LIKE: "Like",
    COMMENT: "Comment",
    AMPLIFY: "Amplify",
    SHARE: "Share",
    AMPLIFIED_BY: "Amplified by",
    LINK_COPIED: "Link copied to clipboard!",
    EDIT_PROFILE: "Edit Profile",
    MY_CALENDAR: "My Calendar",
    SETTINGS: "Settings",
    LANGUAGE: "Interface Language",
    PREFERENCES: "Preferences",
    SECURITY: "Security",
    MY_PROFILE: "My Profile",
    FOR_YOU: "For You",
    MY_ENDORSEMENTS: "My Endorsements",
    WHO_ENDORSED_ME: "Who Endorsed Me",
    SUGGEST_IMPROVEMENTS: "Suggest Improvements",
    SETTINGS_SUBTITLE: "Manage your account preferences, security, and notifications.",
    CALENDAR_SUBTITLE: "Click dates to toggle availability. Colored dots indicate your schedule.",
    NOTIF_PREF: "Notification Preferences",
    MSG_PREF: "Messaging Preferences",
    PRIVACY_VISIBILITY: "Privacy & Visibility",
    ACCOUNT_MGMT: "Account Management",
    DANGER_ZONE: "Danger Zone",
    FREEZE_ACCOUNT: "Freeze Account",
    DELETE_ACCOUNT: "Delete Account Permanently",
    MARK_AVAILABLE: "Mark Available",
    MARK_DAY_OFF: "Mark Day Off",
    CLEAR_STATUS: "Clear Status",
    UPCOMING_EVENTS: "Upcoming Events",
    PAST_EVENTS: "Past Events",
    AVAILABLE: "Available",
    DAY_OFF: "Day Off",
    GIG_EVENT: "Gig / Event",
    SET_STATUS: "Set Status",
    STEALTH_MODE: "Stealth Mode (Scout Mode)",
    STEALTH_DESC: "Browse discreetly without appearing in 'For You' sections.",
    ALLOW_ALL_MSG: "Allow messages from all users",
    ALLOW_PRO_NET: "Allow messages from Pro & Network",
    ALLOW_PRO_ONLY: "Allow messages from Pro Only",
    ALLOW_NET_ONLY: "Allow messages from Network Only",
    NOTIF_NEW_MSG: "New Messages",
    NOTIF_ENDORSE: "New Endorsements",
    NOTIF_COMMENTS: "Comments on my Posts",
    NOTIF_APPS: "New Applications",
    NOTIF_STATUS: "Application Status Changes",
    NOTIF_MATCHES: "New Opportunity Matches",
    TRAVELING_APPLICANT: "Traveling Applicant",
    TRAVELING_DESC: "Overlapping travel plan found for this location.",
    PUBLIC_PROFILE: "Public Profile",
    IDENTITY: "Identity",
    BIO: "Biography",
    PROFESSIONAL_SKILLS: "Professional Skills",
    CORE_INSTRUMENTS: "Core Instruments",
    MAIN_GENRES: "Main Genres",
    SOCIAL_PRESENCE: "Social Presence",
    EMBED_MEDIA: "Embed Media",
    GALLERY_SHOWCASE: "Gallery Showcase",
    RIDER_SPECS: "Rider & Tech Specs",
    TRAVEL_PLANS: "Travel Plans",
    ADD_DESTINATION: "Add Destination",
    TEAM_ACCESS: "Team Access",
    COLLABORATORS: "Collaborators",
    SECURITY_CREDENTIALS: "Security Credentials",
    UPDATE_HANDLE: "Update Unique Handle",
    CURRENT_PASSWORD: "Current Password",
    NEW_PASSWORD: "New Password",
    CONFIRM_PASSWORD: "Confirm Password",
    FANS: "Fans",
    FANS_SUPPORT: "Fans & Support",
    PROJECTS_AFFILIATIONS: "Projects & Affiliations",
    FULL_NAME: "Full Name",
    PROFESSIONAL_TITLE: "Professional Title",
    BASE_CITY: "Base City",
    TERMS_NAV: "Terms & Conditions",
    PRIVACY_NAV: "Privacy Policy",
    COOKIE_NAV: "Cookie Policy",
    EMAIL_VERIFY_TITLE: "Verify Your Email",
    EMAIL_VERIFY_CHECK: "Check your inbox and click the link to access beYourAMP.",
    EMAIL_VERIFY_RESEND: "Resend verification email",
    EMAIL_VERIFY_RESENT: "Email sent! Check your inbox.",
    EMAIL_VERIFY_SUCCESS: "Email verified! Welcome to beYourAMP.",
    EMAIL_VERIFY_INVALID: "Invalid or expired link.",
    EMAIL_VERIFY_NEW_LINK: "Request a new link"
  },
  it: {
    JOIN_STAGE: "Sali sul palco!",
    JOIN_YOUR_STAGE: "Entra in scena!",
    MADE_BY_ARTISTS: "fatto dagli artisti.",
    FOR_ARTISTS: "per gli artisti.",
    SIGN_IN: "Accedi",
    SIGN_UP: "Registrati",
    LOGOUT: "Esci",
    SEARCH_PLACEHOLDER: "Cerca opportunità, utenti, band...",
    NAV_HOME: "Home",
    NAV_MESSAGES: "Messaggi",
    NAV_NOTIFICATIONS: "Notifiche",
    NAV_NETWORK: "Rete",
    NAV_ACTIVITY: "Attività",
    NAV_POST_OPP: "Pubblica",
    NAV_MANAGE_APPLICANTS: "Candidati",
    NAV_FOR_YOU: "Per Te",
    NAV_MY_LINEUPS: "Le mie Lineup",
    NAV_MY_FLYERS: "I miei Flyer",
    NAV_MY_BANDS: "Le mie Band",
    NAV_PROFILE_MANAGER: "Gestione Profili",
    NAV_PUMP_UP: "Pump Up The Volume",
    BACK: "Indietro",
    MESSAGE: "Messaggio",
    ENDORSE: "Endorsa",
    ENDORSED: "Endorsato",
    ENDORSED_BY: "Endorsato da",
    ABOUT: "Info",
    LIKE: "Mi piace",
    COMMENT: "Commenta",
    AMPLIFY: "Amplifica",
    SHARE: "Condividi",
    AMPLIFIED_BY: "Amplificato da",
    LINK_COPIED: "Link copiato!",
    EDIT_PROFILE: "Modifica Profilo",
    MY_CALENDAR: "Mio Calendario",
    SETTINGS: "Impostazioni",
    LANGUAGE: "Lingua Interfaccia",
    PREFERENCES: "Preferenze",
    SECURITY: "Sicurezza",
    MY_PROFILE: "Profilo",
    FOR_YOU: "Per Te",
    MY_ENDORSEMENTS: "I miei Endorsement",
    WHO_ENDORSED_ME: "Chi mi Endorsa",
    SUGGEST_IMPROVEMENTS: "Suggerisci miglioramenti",
    SETTINGS_SUBTITLE: "Gestisci le preferenze del tuo account, la sicurezza e le notifiche.",
    CALENDAR_SUBTITLE: "Clicca sulle date per cambiare disponibilità. I puntini colorati indicano i tuoi impegni.",
    NOTIF_PREF: "Preferenze Notifiche",
    MSG_PREF: "Preferenze Messaggi",
    PRIVACY_VISIBILITY: "Privacy e Visibilità",
    ACCOUNT_MGMT: "Gestione Account",
    DANGER_ZONE: "Zona Pericolo",
    FREEZE_ACCOUNT: "Congela Account",
    DELETE_ACCOUNT: "Elimina Account Permanentemente",
    MARK_AVAILABLE: "Segna come Disponibile",
    MARK_DAY_OFF: "Segna Giorno Libero",
    CLEAR_STATUS: "Cancella Stato",
    UPCOMING_EVENTS: "Eventi in Arrivo",
    PAST_EVENTS: "Eventi Passati",
    AVAILABLE: "Disponibile",
    DAY_OFF: "Giorno Libero",
    GIG_EVENT: "Gig / Evento",
    SET_STATUS: "Imposta Stato",
    STEALTH_MODE: "Modalità Stealth (Scout)",
    STEALTH_DESC: "Naviga discretamente senza apparire nelle sezioni 'Per Te'.",
    ALLOW_ALL_MSG: "Permetti messaggi da tutti",
    ALLOW_PRO_NET: "Solo da membri Pro e Rete",
    ALLOW_PRO_ONLY: "Solo da membri Pro",
    ALLOW_NET_ONLY: "Solo dalla mia Rete",
    NOTIF_NEW_MSG: "Nuovi Messaggi",
    NOTIF_ENDORSE: "Nuove Raccomandazioni",
    NOTIF_COMMENTS: "Commenti ai miei Post",
    NOTIF_APPS: "Nuove Candidature",
    NOTIF_STATUS: "Cambiamenti Stato Candidatura",
    NOTIF_MATCHES: "Nuovi Match Opportunità",
    TRAVELING_APPLICANT: "Candidato in Viaggio",
    TRAVELING_DESC: "Trovato piano di viaggio coincidente per questa località.",
    PUBLIC_PROFILE: "Profilo Pubblico",
    IDENTITY: "Identità",
    BIO: "Biografia",
    PROFESSIONAL_SKILLS: "Skill",
    CORE_INSTRUMENTS: "Strumenti Principali",
    MAIN_GENRES: "Generi",
    SOCIAL_PRESENCE: "Presenza Social",
    EMBED_MEDIA: "Media",
    GALLERY_SHOWCASE: "Galleria",
    RIDER_SPECS: "Rider e Schede Tecniche",
    TRAVEL_PLANS: "Piani di Viaggio",
    ADD_DESTINATION: "Aggiungi Destinazione",
    TEAM_ACCESS: "Accesso Team",
    COLLABORATORS: "Collaboratori",
    SECURITY_CREDENTIALS: "Credenziali di Sicurezza",
    UPDATE_HANDLE: "Aggiorna Handle Unico",
    CURRENT_PASSWORD: "Password Attuale",
    NEW_PASSWORD: "Nuova Password",
    CONFIRM_PASSWORD: "Conferma Nuova Password",
    FANS: "Fan",
    FANS_SUPPORT: "Fan e Supporto",
    PROJECTS_AFFILIATIONS: "Progetti e Affiliazioni",
    FULL_NAME: "Nome Completo",
    PROFESSIONAL_TITLE: "Titolo Professionale",
    BASE_CITY: "Città di Base",
    TERMS_NAV: "Termini e Condizioni",
    PRIVACY_NAV: "Privacy Policy",
    COOKIE_NAV: "Cookie Policy",
    EMAIL_VERIFY_TITLE: "Verifica la tua Email",
    EMAIL_VERIFY_CHECK: "Controlla la tua casella e clicca il link per accedere a beYourAMP.",
    EMAIL_VERIFY_RESEND: "Rinvia email di verifica",
    EMAIL_VERIFY_RESENT: "Email inviata! Controlla la casella.",
    EMAIL_VERIFY_SUCCESS: "Email verificata! Benvenuto su beYourAMP.",
    EMAIL_VERIFY_INVALID: "Link non valido o scaduto.",
    EMAIL_VERIFY_NEW_LINK: "Richiedi un nuovo link"
  }
};

export type LanguageCode = keyof typeof translations;